module.exports = __webpack_public_path__ + "components/media-kit/static/display-desktop-062e5e86c5a24247ae62f4a640f69638.png";